import $ from "jquery";

const bloglisting = {
  variables: {
    parent: ".blog-listing",
    loadMore: ".blog-listing--loadmore-btn",
    loadMoreWrap: ".blog-listing--loadmore-wrap",
    listingCol: ".blog-listing--col",
    hiddenCol: ".blog-listing--col.d-none",
    tagsWrap: ".blog-listing--card__tag",
    count: 0,
  },
  methods: {
    createCard: (data) => {

      const readMoreText = $(".blog-listing").data("read-more");

      const card = ` <div class="col-md-4 blog-listing--col mb-4 mb-md-8">

      <a class="text-decoration-none w-100 d-block" href="${
        data.path
      }" title="${data.path}">
      <div class="blog-listing--card">
          <div class="blog-listing--card__thumbnail position-relative">
            <picture>
              <img
                src="${data.image}"
                class="object-fit-cover h-100 w-100"
                alt="${data.imageAlt}"
                title="${data.imageAlt}"
              />
            </picture>
            <div
              class="blog-listing--card__tag position-absolute text-uppercase ${
                data.tag == "" ? "d-none" : ""
              }"
            >
                ${data.tag}

            </div>
          </div>
          <div class="blog-listing--card__info">
            <div
              class="blog-listing--card__info--icontext d-md-none mb-3 d-flex"
            >
              <div class="labels pe-4 d-flex align-items-center gap-2" ${
                data.date == "" ? "d-none" : ""
              }">
                <svg class="icon">
                  <use
                    xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#date"
                  ></use>
                </svg>
                ${data.date}
              </div>
              <div
                class="ps-2 pe-3 labels labels--mid d-flex align-items-center gap-2 d-none ${
                  data.views == "" ? "d-none" : ""
                }"
              >
                <svg class="icon">
                  <use
                    xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#eye-stroke"
                  ></use>
                </svg>

                ${data.views} Views
              </div>
              <div class="ps-2 labels d-flex align-items-center gap-2 ${
                data.duration == "" ? "d-none" : ""
              }">
                <svg class="icon">
                  <use
                    xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#clock"
                  ></use>
                </svg>
                ${data.duration} minute read
              </div>
            </div>
            <h3 class="blog-listing--card__info--title mb-3 ${
              data.title == "" ? "d-none" : ""
            }">
              ${data.title}
            </h3>

            <div
              class="blog-listing--card__info--icontext d-none mb-2 mb-md-3 d-md-flex ${
                data.date == "" ? "d-none" : ""
              }"
            >
              <div class="labels pe-4 d-flex align-items-center gap-2">
                <svg class="icon">
                  <use
                    xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#calendar"
                  ></use>
                </svg>
                ${data.date}
              </div>
              <div
                class="ps-2 pe-3 labels labels--mid d-flex align-items-center gap-2 d-none ${
                  data.views == "" ? "d-none" : ""
                }"
              >
                <svg class="icon">
                  <use
                    xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#eye-stroke"
                  ></use>
                </svg>

                ${data.views} Views
              </div>
              <div class="ps-2 labels d-flex align-items-center gap-2 ${
                data.duration == "" ? "d-none" : ""
              }">
                <svg class="icon">
                  <use
                    xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#clock"
                  ></use>
                </svg>
                ${data.duration} minute read
              </div>
            </div>
            <p class="blog-listing--card__info--desc mb-4">${data.desc}</p>

            <a

              class="blog-listing--card__info--cta px-5 px-md-0 d-flex align-items-center gap-2 text-decoration-none d-none d-md-block"
            href="${data.path}" title="${data.path}" aria-label="${readMoreText} ${data.title}"
              >

            ${readMoreText}
              <svg class="arrow mx-2">
                <use
                  xlink:href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#arrow-right"
                ></use>
              </svg>
            </a>
          </div>
        </div>
        </a>
      </div>`;
      return card;
    },
    appendListCards: (element, data) => {
  const parentContainer = element.find(".blog-listing--wrap");
  parentContainer.empty();
  if (data.length != 0) {
    data.forEach((cardData, index) => {
      const formattedDate = bloglisting.methods.formatDate(cardData.date);

      let path = cardData.resourcePath || "";

      const cardDetails = {
        path: path,
        image: cardData.imagePath,
        imageAlt: cardData.imageAltText,
        title: cardData.title ? cardData.title : "",
        date: cardData.date ? formattedDate : "",
        duration: cardData.duration ? cardData.duration : "",
        views: cardData.views ? cardData.views : "",
        desc: cardData.pageDesc ? cardData.pageDesc : "",
        tag: cardData.blogCategory ? cardData.blogCategory : "",
      };
      const card = bloglisting.methods.createCard(cardDetails);
      parentContainer.append(card);
      bloglisting.methods.readMoreClickHandler();
    });
  } else {
    let errorMsg = $("#blogListing").data("error-msg");
    let emptyResults;
    if (errorMsg != undefined) {
      emptyResults = `<h3>${errorMsg}</h3>`;
    } else {
      emptyResults = `<h3>No Results Found</h3>`;
    }
    parentContainer.append(emptyResults);
  }
},

    fetchListData: () => {
    $(".blog-listing").each((index, element) => {
    let listingPath = "/bin/chli/bloglisting";
    let listingPage = $(element).data("target-page");
    if (listingPath && typeof listingPage === "string" && listingPage.length < 200) {

      // Extract blog name
      let targetPage = listingPage.split('/').filter(Boolean).pop();

      // Extract language after /in/
      let lang = listingPage.match(/\/in\/([a-z]{2})\//i)?.[1] || "en";

      console.log("targetPage:", targetPage);
      console.log("lang:", lang);

      $.ajax({
        type: "GET",
        url: `${listingPath}.json?blogName=${targetPage}&lang=${lang}`,

        success: (result) => {
          let resJSON = JSON.parse(JSON.stringify(result));
          bloglisting.methods.appendListCards($(element), result);
          bloglisting.methods.hideExtra();
          bloglisting.methods.initiateSearch(resJSON, $(element));
          bloglisting.methods.yearFilter(resJSON, $(element));
          bloglisting.methods.activeYears(resJSON);
        },
        error: (xhr, status, error) => {
          console.error("Request failed:", error);
        },
      });
    }
  });
},

    showItems: () => {
      let limit;
      if (screen.width < 768) {
        limit = $(bloglisting.variables.parent).data("mob-limit");
      } else {
        limit = $(bloglisting.variables.parent).data("limit");
      }

      bloglisting.variables.count = limit;

      $(bloglisting.variables.loadMore).on("click", function () {
        $(bloglisting.variables.listingCol)
          .slice(
            bloglisting.variables.count,
            bloglisting.variables.count + limit
          )
          .removeClass("d-none");
        bloglisting.variables.count = bloglisting.variables.count + limit;
        bloglisting.methods.hideBtn();
      });
    },

    hideBtn: () => {
      if ($(bloglisting.variables.hiddenCol).length == 0) {
        $(bloglisting.variables.loadMoreWrap).addClass("d-none");
      } else {
        $(bloglisting.variables.loadMoreWrap).removeClass("d-none");
      }
    },

    hideExtra: () => {
      let limit;
      if (screen.width < 768) {
        limit = $(bloglisting.variables.parent).data("mob-limit");
      } else {
        limit = $(bloglisting.variables.parent).data("limit");
      }

      const length = $(bloglisting.variables.listingCol).length;
      $(bloglisting.variables.listingCol)
        .slice(limit, length)
        .addClass("d-none");
      bloglisting.methods.hideBtn();
    },

    activeYears: (json) => {
      let activeYearList = (json) => {
        let uniqueYears = json
          .map((item) => item.year)
          .filter((value, index, current) => current.indexOf(value) === index);
        return uniqueYears.sort();
      };

      bloglisting.methods.appendYears(activeYearList(json));
    },

    appendYears: (years) => {
      let options = "";
      for (let i = 0; i < years.length; i++) {
        options += `<option value="${years[i]}">${years[i]}</option>`;
      }

      $("#seachYearFilter1").append(options);
      $("#seachYearFilter2").append(options);
    },

    initiateSearch: (resJSON, element) => {
      $("#searchTextInput").on("keyup", function () {
        bloglisting.methods.searchBlogs(resJSON, element);
      });
    },

    yearFilter: (resJSON, element) => {
      $("#seachYearFilter1").on("change", function () {
        $("#seachYearFilter2").val($("#seachYearFilter1").val());
        bloglisting.methods.searchBlogs(resJSON, element);
      });
      $("#seachYearFilter2").on("change", function () {
        $("#seachYearFilter1").val($("#seachYearFilter2").val());

        bloglisting.methods.searchBlogs(resJSON, element);
      });
    },

    searchBlogs: (resJSON, parent) => {
      if (screen.width < 768) {
        bloglisting.variables.count = $(bloglisting.variables.parent).data(
          "mob-limit"
        );
      } else {
        bloglisting.variables.count = $(bloglisting.variables.parent).data(
          "limit"
        );
      }
      const searchText = $("#searchTextInput").val();
      const blogFilter = $("#seachYearFilter1").val();

      let filteredResults;

      switch (true) {
        case searchText.length != 0 && blogFilter != "all":
          filteredResults = resJSON.filter((elem) => {
            return (
              (elem.title.toLowerCase().includes(searchText.toLowerCase())&&
              String(elem.year) == String(blogFilter)) ||
              ("authorName" in elem &&
                elem.authorName
                  .toLowerCase()
                  .includes(searchText.toLowerCase()) &&
                String(elem.year) == String(blogFilter))
            );
          });
          bloglisting.methods.afterFilter(parent, filteredResults);
          break;
        case searchText.length == 0 && blogFilter != "all":
          filteredResults = resJSON.filter((elem) => {
            return String(elem.year) == String(blogFilter);
          });
          bloglisting.methods.afterFilter(parent, filteredResults);
          break;
        case searchText.length != 0 && blogFilter == "all":
          filteredResults = resJSON.filter((elem) => {
            return (
              elem.title.toLowerCase().includes(searchText.toLowerCase()) ||
              ("authorName" in elem &&
                elem.authorName
                  .toLowerCase()
                  .includes(searchText.toLowerCase()))
            );
          });
          bloglisting.methods.afterFilter(parent, filteredResults);

          break;
        case searchText.length == 0 && blogFilter == "all":
          bloglisting.methods.afterFilter(parent, resJSON);

          break;
      }
    },

    afterFilter: (parent, data) => {
      bloglisting.methods.appendListCards(parent, data);
      bloglisting.methods.hideExtra();
    },

    formatDate: (dateStr) => {
      if (dateStr != "") {
        const date = new Date(dateStr);

        const day = date.getDate();
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear().toString().slice(-2);

        const formattedDate = `${day} ${month} ‘${year}`;

        return formattedDate;
      }
    },
    readMoreClickHandler: function () {
          $(".blog-listing--wrap .blog-listing--card").off("click").on("click", function (e) {
            let blogCardSection = $(this).find(".blog-listing--card__info");
            let titleText=blogCardSection.find(".blog-listing--card__info--title").text().replace(/\n/g, '').trim();
            let section =blogCardSection.closest(".blog-listing");
            let buttonName = $(this).find('.blog-listing--card__info--cta').text().replace(/\n/g, '').trim();
            let sectionText= section.find(".heading-3").text().replace(/\n/g, '').trim();
            let eventObj = { buttonText: buttonName,
                    articleName: titleText,
                    pageSection: sectionText
                    };
            let obj = bloglisting.methods.dataLayerObj(eventObj);
            createDataLayer("buttonClick", obj);
          });
        },

    blogLoadMoreClickHandler: function () {
      $(".blog-listing--loadmore-btn").on("click", function () {
        let buttonText = document.querySelector(
          ".blog-listing--loadmore-btn"
        ).innerText;
        let section =$(this).closest(".blog-listing");
        let sectionText= section.find(".heading-3").text().replace(/\n/g, '').trim();
        let eventObj = { buttonText: buttonText,
         pageSection: sectionText};
        let obj = bloglisting.methods.dataLayerObj(eventObj);
        createDataLayer("buttonClick", obj);
      });
    },
    blogSearchClickHandler: function () {
      $("#searchTextInput").on("focus", function () {
      let term = $(this).val();
      let section =$(this).closest(".blog-listing");
      let sectionText= section.find(".heading-3").text().replace(/\n/g, '').trim();
      let eventObj = { searchTerm: term,
                   pageSection: sectionText};
        let obj = bloglisting.methods.dataLayerObj(eventObj);
        createDataLayer("SearchClicked", obj);
      });
    },

    blogSearchTerm: function(){
         let timeout;
        $("#searchTextInput").on('keyup', function() {
        const $this = $(this);
            clearTimeout(timeout);
            timeout = setTimeout(function() {
            let term = $this.val();
            let section =$this.closest(".blog-listing");
            let sectionText= section.find(".heading-3").text().replace(/\n/g, '').trim();
            let eventObj = { searchTerm: term,
             pageSection: sectionText};
            let obj = bloglisting.methods.dataLayerObj(eventObj);
            createDataLayer("enter_search_keyword", obj);
            }, 3000);
        });
    },

    formSubmit: function () {
      $("#blogListingForm").on("submit", function (e) {
        e.preventDefault();
      });
    },

    dataLayerObj: function (e) {
      let obj = {
        'articleName': e.articleName ? e.articleName : "",
        'blogCategory': "",
        'blogPageCategory': "",
        'buttonText': (e != undefined? "buttonText" in e  ? e.buttonText  ? e.buttonText.trim() : "" : "" : ""),
        'pageSection':e.pageSection ? e.pageSection : "Blog Listing",
        'pageType':
          document.querySelector("meta[name='template']").content ==
          "chli-base-page-template"
            ? window.location.href.includes("blog")
              ? "Blogs"
              : window.location.href.substring(
                  window.location.href.indexOf(".com/"),
                  window.location.href.length
                ) === ".com/"
              ? "Home"
              : "Other Pages"
            : "Blog Details Page",
        'planOption': "",
        'productCategory': "",
        'productName': "",
        'question': "",
        'source': "",
        'searchTerm':
          e != undefined
            ? "searchTerm" in e
              ? e.searchTerm
                ? e.searchTerm.trim()
                : ""
              : ""
            : "",
        'videoTitle': "",
        'bannerName': "",
      };
      return obj;
    },
  },
};

$(() => {
  if ($(".blog-listing").length > 0) {
    bloglisting.methods.fetchListData();
    bloglisting.methods.showItems();
    bloglisting.methods.blogLoadMoreClickHandler();
    bloglisting.methods.blogSearchClickHandler();
    bloglisting.methods.formSubmit();
    bloglisting.methods.blogSearchTerm();
  }
});
